import React, { useEffect, useState } from 'react'
import { getSingleProject } from '../../services/WorkApi';
import { Avatar, Card, CardHeader, Typography } from '@mui/material';

const ProjectDisplay = ({ projectId }) => {
    const [projectData, setProjectData] = useState(null);

    useEffect(() => {
        if (!projectId) {
            console.error("Project projectId is required");
            return;
        }

        getSingleProject(projectId)
            .then((data) => {
                console.log("Project Data:", data);
                setProjectData(data.data);
            })
            .catch((error) => {
                console.error("Error fetching project data:", error);
            });
    }, [projectId]);

    if (!projectData) return <Typography variant='caption'>Loading...</Typography>;

    return (
        <>
            <Card elevation={0}>
                <CardHeader
                    title={projectData.title}
                    subheader={projectData.synopsis}
                    avatar={
                        <Avatar
                        variant='square'
                            sx={{ width: 56, height: 56 }}
                            src={projectData.poster_image}
                            alt={projectData.title}
                        />
                    }
                     sx={{padding:0}}
                />
            </Card>
        </>
    );
};

export default ProjectDisplay;
